import { Brands } from '@/modules/brand-portal/types';
import { all_roles } from '@/utils';

const access_roles = {
  [Brands.Pages.BRAND]: all_roles,
  [Brands.Pages.DESIGN]: all_roles,
};

export default access_roles;
